import React, { useState } from 'react';
import SubMenuBox from './SubMenuBox';

import './subMenu.css';

const SubMenu = props => {
  const { menuList } = props;
  const [activeSubMenu, setActiveSubMenu] = useState(null);
  const [activeMenu, setActiveMenu] = useState(null);

  const setSubMenu = (subMenu, index) => {
    setActiveSubMenu(subMenu || null);
    setActiveMenu(index || null);
  };

  return (
    <ul className="subMenu showWithAnimate" onMouseLeave={() => setSubMenu()}>
      {menuList.map((menu, index) => (
        <li
          onMouseEnter={() => setSubMenu(menu.subMenu, index + 1)}
          className={activeMenu === index + 1 ? 'active' : ''}
          key={menu.name}
        >
          <a>
            {menu.name}
            <span className="arrow arrowDown" />
          </a>
        </li>
      ))}
      {activeSubMenu && (
        <div className="subMenuOpnView">
          <SubMenuBox menuDetail={activeSubMenu} activeMenu={activeMenu} />
        </div>
      )}
    </ul>
  );
};

export default SubMenu;
